﻿const variables = {}
variables.siteTitle = 'BIFA Voting'
variables.year = '2024'

export default variables
